
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {bus} from "@/plugins/bus";
  import {IBus} from "@/interfaces/bus-actions";
  import AppMenuBtn from "@/components/AppMenuBtn.vue";

  @Component({
    components: {
      AppMenuBtn,
    }
  })
  export default class AppPageHeader extends Vue {
    @Prop() pageTitle: string;
    @Prop() routeBack!: { label: string; route: ROUTE_NAME;  action: Function; hidden: boolean; };
    @Prop() routeBackDefault!: string;
    @Prop() fullLayout!: boolean;

    displayMenu = false;

    get hasRouteBack() { return Boolean(window.history.state); }
    get refMode() { return this.$store.state.profile.refMode; }

    mounted() {
      bus.$on(IBus.AppMenuAction.Close, () => this.displayMenu = false);
    }

    async goBack () {
      if (this.routeBack) {
        if (this.routeBack.route) await this.$store.dispatch('openPage', { routeName: this.routeBack.route });
        else await this.routeBack.action();
      }
      else {
        if (this.hasRouteBack) this.$router.go(-1);
        else await this.$store.dispatch('openPage', { routeName: this.routeBackDefault ? this.routeBackDefault : ROUTE_NAME.PAGE_CAR_LIST });
      }
    }

    toggleMenu() {
      this.displayMenu = !this.displayMenu;
      bus.$emit(this.displayMenu ? IBus.AppMenuAction.Display : IBus.AppMenuAction.Close);
    }
  }
